
<div class="Page404Contain justify-content-center align-items-center">
    <div class="Page404 justify-content-center align-items-center">
        <h1>404</h1>
        <p>OOPS, SORRY WE CAN'T FIND THAT PAGE!</p>
        <div><label>Either something went wrong or the page doesn't exist anymore.</label></div>
        <button class="btn-bd-empty">
            <a routerLink="/dashboard">Home Page</a>
        </button>
    </div>
</div>